export default {
    init: function() {
      return new Promise((resolve) => {
        // 如果已加载直接返回
        if (typeof window.T !== 'undefined') {
          //console.log('地图脚本初始化成功1111...')
          resolve(window.T)
          return true
        }
        window.onload = function() {
          //console.log('地图脚本初始化成功...')
          resolve(window.T)
        }
      })
    }
  }